import { App } from 'vue'
import SvgIconWithText from './SvgIconWithText.vue'

export default {
  install(app: App) {
    app.component('svg-icon-with-text', SvgIconWithText)
  }
}
